// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AlternateMatchEnum,
  Problem,
  RealtimeModeEnum,
  StrictnessForTripIdEnum,
  TrainStopAssignmentsEnum,
  TripResponse,
  TripsByLegRequestBody,
  TripsByOriginAndDestinationRequestBody,
  TripsIntervalByOriginAndDestinationRequestBody,
} from '../models/index';
import {
    AlternateMatchEnumFromJSON,
    AlternateMatchEnumToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    RealtimeModeEnumFromJSON,
    RealtimeModeEnumToJSON,
    StrictnessForTripIdEnumFromJSON,
    StrictnessForTripIdEnumToJSON,
    TrainStopAssignmentsEnumFromJSON,
    TrainStopAssignmentsEnumToJSON,
    TripResponseFromJSON,
    TripResponseToJSON,
    TripsByLegRequestBodyFromJSON,
    TripsByLegRequestBodyToJSON,
    TripsByOriginAndDestinationRequestBodyFromJSON,
    TripsByOriginAndDestinationRequestBodyToJSON,
    TripsIntervalByOriginAndDestinationRequestBodyFromJSON,
    TripsIntervalByOriginAndDestinationRequestBodyToJSON,
} from '../models/index';

export interface GetTripsByIdRequest {
    id: string;
    requestID?: string;
    acceptLanguage?: GetTripsByIdAcceptLanguageEnum;
    date?: Date;
    realtimeMode?: RealtimeModeEnum;
    retryFuzzy?: boolean;
    strictness?: StrictnessForTripIdEnum;
    includeAlternateMatch?: AlternateMatchEnum;
    includeRouteProjection?: boolean;
    includeOperatingDays?: boolean;
    includeSummary?: boolean;
    includeIntermediateStops?: GetTripsByIdIncludeIntermediateStopsEnum;
    includeTrainStopAssignments?: TrainStopAssignmentsEnum;
    exludeUnnecessaryTransfers?: boolean;
}

export interface GetTripsByIdAndPartialSearchContextRequest {
    id: string;
    viaEarlierLaterContext: string;
    requestID?: string;
    acceptLanguage?: GetTripsByIdAndPartialSearchContextAcceptLanguageEnum;
    additionalTransferTime?: number;
    includeAlternateMatch?: AlternateMatchEnum;
    includeRouteProjection?: boolean;
    includeSummary?: boolean;
    includeIntermediateStops?: GetTripsByIdAndPartialSearchContextIncludeIntermediateStopsEnum;
    exludeUnnecessaryTransfers?: boolean;
}

export interface GetTripsByLegRequest {
    tripsByLegRequestBody: TripsByLegRequestBody;
    requestID?: string;
    acceptLanguage?: GetTripsByLegAcceptLanguageEnum;
}

export interface GetTripsByOriginAndDestinationRequest {
    tripsByOriginAndDestinationRequestBody: TripsByOriginAndDestinationRequestBody;
    requestID?: string;
    acceptLanguage?: GetTripsByOriginAndDestinationAcceptLanguageEnum;
}

export interface GetTripsByRedefinitionRequest {
    id: string;
    requestID?: string;
    acceptLanguage?: GetTripsByRedefinitionAcceptLanguageEnum;
    redefinedOrigin?: string;
    redefinedDestination?: string;
}

export interface GetTripsByRoadRequest {
    origin: string;
    destination: string;
    requestID?: string;
    acceptLanguage?: GetTripsByRoadAcceptLanguageEnum;
}

export interface GetTripsIntervalByOriginAndDestinationRequest {
    tripsIntervalByOriginAndDestinationRequestBody: TripsIntervalByOriginAndDestinationRequestBody;
    requestID?: string;
    acceptLanguage?: GetTripsIntervalByOriginAndDestinationAcceptLanguageEnum;
}

/**
 * 
 */
export class TripsV3Api extends runtime.BaseAPI {

    /**
     * Typically there is [1] hit but failing `Problem` must be expected in realtime scenarios or older `Trip::id\'s`. Rare [2] hit cases might resolve from includeAlternateMatch=BOTH. <br/>The response can be cached during 15 seconds.
     * Get corresponding trip for a specific `Trip::id`.
     */
    async getTripsByIdRaw(requestParameters: GetTripsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TripResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTripsById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = (requestParameters['date'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['realtimeMode'] != null) {
            queryParameters['realtimeMode'] = requestParameters['realtimeMode'];
        }

        if (requestParameters['retryFuzzy'] != null) {
            queryParameters['retryFuzzy'] = requestParameters['retryFuzzy'];
        }

        if (requestParameters['strictness'] != null) {
            queryParameters['strictness'] = requestParameters['strictness'];
        }

        if (requestParameters['includeAlternateMatch'] != null) {
            queryParameters['includeAlternateMatch'] = requestParameters['includeAlternateMatch'];
        }

        if (requestParameters['includeRouteProjection'] != null) {
            queryParameters['includeRouteProjection'] = requestParameters['includeRouteProjection'];
        }

        if (requestParameters['includeOperatingDays'] != null) {
            queryParameters['includeOperatingDays'] = requestParameters['includeOperatingDays'];
        }

        if (requestParameters['includeSummary'] != null) {
            queryParameters['includeSummary'] = requestParameters['includeSummary'];
        }

        if (requestParameters['includeIntermediateStops'] != null) {
            queryParameters['includeIntermediateStops'] = requestParameters['includeIntermediateStops'];
        }

        if (requestParameters['includeTrainStopAssignments'] != null) {
            queryParameters['includeTrainStopAssignments'] = requestParameters['includeTrainStopAssignments'];
        }

        if (requestParameters['exludeUnnecessaryTransfers'] != null) {
            queryParameters['exludeUnnecessaryTransfers'] = requestParameters['exludeUnnecessaryTransfers'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['requestID'] != null) {
            headerParameters['Request-ID'] = String(requestParameters['requestID']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/trips/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TripResponseFromJSON(jsonValue));
    }

    /**
     * Typically there is [1] hit but failing `Problem` must be expected in realtime scenarios or older `Trip::id\'s`. Rare [2] hit cases might resolve from includeAlternateMatch=BOTH. <br/>The response can be cached during 15 seconds.
     * Get corresponding trip for a specific `Trip::id`.
     */
    async getTripsById(requestParameters: GetTripsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TripResponse> {
        const response = await this.getTripsByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Useful to adapt a given `Trip` slightly with same origin/destination but _earlier arrival_ or _later departure_ at a desired via/transfer `ScheduledStopPoint` (similar effect could be gained by v3/trips/by-origin-destination `PTViaReference::waittime`). `TripResponse::paginationCursor` cannot be provided in this case.
     * Get a `Trip` [0..1] with changed arrival/departure times at a concrete via/transfer point on a given `Trip::id` (aka partialTripSearch).
     */
    async getTripsByIdAndPartialSearchContextRaw(requestParameters: GetTripsByIdAndPartialSearchContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TripResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTripsByIdAndPartialSearchContext().'
            );
        }

        if (requestParameters['viaEarlierLaterContext'] == null) {
            throw new runtime.RequiredError(
                'viaEarlierLaterContext',
                'Required parameter "viaEarlierLaterContext" was null or undefined when calling getTripsByIdAndPartialSearchContext().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['additionalTransferTime'] != null) {
            queryParameters['additionalTransferTime'] = requestParameters['additionalTransferTime'];
        }

        if (requestParameters['includeAlternateMatch'] != null) {
            queryParameters['includeAlternateMatch'] = requestParameters['includeAlternateMatch'];
        }

        if (requestParameters['includeRouteProjection'] != null) {
            queryParameters['includeRouteProjection'] = requestParameters['includeRouteProjection'];
        }

        if (requestParameters['includeSummary'] != null) {
            queryParameters['includeSummary'] = requestParameters['includeSummary'];
        }

        if (requestParameters['includeIntermediateStops'] != null) {
            queryParameters['includeIntermediateStops'] = requestParameters['includeIntermediateStops'];
        }

        if (requestParameters['exludeUnnecessaryTransfers'] != null) {
            queryParameters['exludeUnnecessaryTransfers'] = requestParameters['exludeUnnecessaryTransfers'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['requestID'] != null) {
            headerParameters['Request-ID'] = String(requestParameters['requestID']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/trips/{id}/{viaEarlierLaterContext}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"viaEarlierLaterContext"}}`, encodeURIComponent(String(requestParameters['viaEarlierLaterContext']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TripResponseFromJSON(jsonValue));
    }

    /**
     * Useful to adapt a given `Trip` slightly with same origin/destination but _earlier arrival_ or _later departure_ at a desired via/transfer `ScheduledStopPoint` (similar effect could be gained by v3/trips/by-origin-destination `PTViaReference::waittime`). `TripResponse::paginationCursor` cannot be provided in this case.
     * Get a `Trip` [0..1] with changed arrival/departure times at a concrete via/transfer point on a given `Trip::id` (aka partialTripSearch).
     */
    async getTripsByIdAndPartialSearchContext(requestParameters: GetTripsByIdAndPartialSearchContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TripResponse> {
        const response = await this.getTripsByIdAndPartialSearchContextRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Assuming there is a known disturbance coming, this API is useful to find other Trip options to get to the final destination from the view of the passenger\'s current position.
     * {Idempotent: GET with body payload} Perform a trip search starting at a position on a current `PTRideLeg` where a passenger is on its way on a planned Trip (aka search on trip (sot)).
     */
    async getTripsByLegRaw(requestParameters: GetTripsByLegRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TripResponse>> {
        if (requestParameters['tripsByLegRequestBody'] == null) {
            throw new runtime.RequiredError(
                'tripsByLegRequestBody',
                'Required parameter "tripsByLegRequestBody" was null or undefined when calling getTripsByLeg().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['requestID'] != null) {
            headerParameters['Request-ID'] = String(requestParameters['requestID']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/trips/by-leg`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TripsByLegRequestBodyToJSON(requestParameters['tripsByLegRequestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TripResponseFromJSON(jsonValue));
    }

    /**
     * Assuming there is a known disturbance coming, this API is useful to find other Trip options to get to the final destination from the view of the passenger\'s current position.
     * {Idempotent: GET with body payload} Perform a trip search starting at a position on a current `PTRideLeg` where a passenger is on its way on a planned Trip (aka search on trip (sot)).
     */
    async getTripsByLeg(requestParameters: GetTripsByLegRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TripResponse> {
        const response = await this.getTripsByLegRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The underlying public transportation planner will provide the best journey-connections according to your query-parameters, such as via, individual change time (ICT) etc.<br>Between 0 and about 12 hits are expectable, related to realtime circumstances.
     * {Idempotent: GET with body payload} Get one-way trips between given origin and destination locations. Each Leg is operated by a certain transport-product, therefore multiple legs means changing vehicles.
     */
    async getTripsByOriginAndDestinationRaw(requestParameters: GetTripsByOriginAndDestinationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TripResponse>> {
        if (requestParameters['tripsByOriginAndDestinationRequestBody'] == null) {
            throw new runtime.RequiredError(
                'tripsByOriginAndDestinationRequestBody',
                'Required parameter "tripsByOriginAndDestinationRequestBody" was null or undefined when calling getTripsByOriginAndDestination().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['requestID'] != null) {
            headerParameters['Request-ID'] = String(requestParameters['requestID']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/trips/by-origin-destination`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TripsByOriginAndDestinationRequestBodyToJSON(requestParameters['tripsByOriginAndDestinationRequestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TripResponseFromJSON(jsonValue));
    }

    /**
     * The underlying public transportation planner will provide the best journey-connections according to your query-parameters, such as via, individual change time (ICT) etc.<br>Between 0 and about 12 hits are expectable, related to realtime circumstances.
     * {Idempotent: GET with body payload} Get one-way trips between given origin and destination locations. Each Leg is operated by a certain transport-product, therefore multiple legs means changing vehicles.
     */
    async getTripsByOriginAndDestination(requestParameters: GetTripsByOriginAndDestinationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TripResponse> {
        const response = await this.getTripsByOriginAndDestinationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Usage: for e.g. strip-off international journey-part from trips starting or ending in Switzerland to get a valid NOVA ticketing offre.
     * Split given `Trip` referenced by its `id` by redefined origin and/or destination into a partial (shortened) subtrip (where a typical split-point might be a `StopPlace::isTariffborder`).
     */
    async getTripsByRedefinitionRaw(requestParameters: GetTripsByRedefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TripResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTripsByRedefinition().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['redefinedOrigin'] != null) {
            queryParameters['redefinedOrigin'] = requestParameters['redefinedOrigin'];
        }

        if (requestParameters['redefinedDestination'] != null) {
            queryParameters['redefinedDestination'] = requestParameters['redefinedDestination'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['requestID'] != null) {
            headerParameters['Request-ID'] = String(requestParameters['requestID']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/INCUBATOR/trips/by-redefinition/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TripResponseFromJSON(jsonValue));
    }

    /**
     * Usage: for e.g. strip-off international journey-part from trips starting or ending in Switzerland to get a valid NOVA ticketing offre.
     * Split given `Trip` referenced by its `id` by redefined origin and/or destination into a partial (shortened) subtrip (where a typical split-point might be a `StopPlace::isTariffborder`).
     */
    async getTripsByRedefinition(requestParameters: GetTripsByRedefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TripResponse> {
        const response = await this.getTripsByRedefinitionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get road route by underlying router (no public transportation modes included). Returns one trip with very limited request options and response data.
     */
    async getTripsByRoadRaw(requestParameters: GetTripsByRoadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TripResponse>> {
        if (requestParameters['origin'] == null) {
            throw new runtime.RequiredError(
                'origin',
                'Required parameter "origin" was null or undefined when calling getTripsByRoad().'
            );
        }

        if (requestParameters['destination'] == null) {
            throw new runtime.RequiredError(
                'destination',
                'Required parameter "destination" was null or undefined when calling getTripsByRoad().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['origin'] != null) {
            queryParameters['origin'] = requestParameters['origin'];
        }

        if (requestParameters['destination'] != null) {
            queryParameters['destination'] = requestParameters['destination'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['requestID'] != null) {
            headerParameters['Request-ID'] = String(requestParameters['requestID']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/INCUBATOR/trips/by-road`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TripResponseFromJSON(jsonValue));
    }

    /**
     * Get road route by underlying router (no public transportation modes included). Returns one trip with very limited request options and response data.
     */
    async getTripsByRoad(requestParameters: GetTripsByRoadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TripResponse> {
        const response = await this.getTripsByRoadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The underlying public transportation planner will provide the best journey-connections according to your query-parameters, such as via, individual change time (ICT) etc.
     * {Idempotent: GET with body payload} Get one-way trip-intervals for Public Transportation (PT) between given origin and destination `StopPlace`. Analog /trips but within duration interval.
     */
    async getTripsIntervalByOriginAndDestinationRaw(requestParameters: GetTripsIntervalByOriginAndDestinationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TripResponse>> {
        if (requestParameters['tripsIntervalByOriginAndDestinationRequestBody'] == null) {
            throw new runtime.RequiredError(
                'tripsIntervalByOriginAndDestinationRequestBody',
                'Required parameter "tripsIntervalByOriginAndDestinationRequestBody" was null or undefined when calling getTripsIntervalByOriginAndDestination().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['requestID'] != null) {
            headerParameters['Request-ID'] = String(requestParameters['requestID']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/trips/intervals/by-origin-destination`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TripsIntervalByOriginAndDestinationRequestBodyToJSON(requestParameters['tripsIntervalByOriginAndDestinationRequestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TripResponseFromJSON(jsonValue));
    }

    /**
     * The underlying public transportation planner will provide the best journey-connections according to your query-parameters, such as via, individual change time (ICT) etc.
     * {Idempotent: GET with body payload} Get one-way trip-intervals for Public Transportation (PT) between given origin and destination `StopPlace`. Analog /trips but within duration interval.
     */
    async getTripsIntervalByOriginAndDestination(requestParameters: GetTripsIntervalByOriginAndDestinationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TripResponse> {
        const response = await this.getTripsIntervalByOriginAndDestinationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetTripsByIdAcceptLanguageEnum = {
    De: 'de',
    Fr: 'fr',
    It: 'it',
    En: 'en'
} as const;
export type GetTripsByIdAcceptLanguageEnum = typeof GetTripsByIdAcceptLanguageEnum[keyof typeof GetTripsByIdAcceptLanguageEnum];
/**
 * @export
 */
export const GetTripsByIdIncludeIntermediateStopsEnum = {
    All: 'ALL',
    BoardingAlighting: 'BOARDING_ALIGHTING',
    None: 'NONE'
} as const;
export type GetTripsByIdIncludeIntermediateStopsEnum = typeof GetTripsByIdIncludeIntermediateStopsEnum[keyof typeof GetTripsByIdIncludeIntermediateStopsEnum];
/**
 * @export
 */
export const GetTripsByIdAndPartialSearchContextAcceptLanguageEnum = {
    De: 'de',
    Fr: 'fr',
    It: 'it',
    En: 'en'
} as const;
export type GetTripsByIdAndPartialSearchContextAcceptLanguageEnum = typeof GetTripsByIdAndPartialSearchContextAcceptLanguageEnum[keyof typeof GetTripsByIdAndPartialSearchContextAcceptLanguageEnum];
/**
 * @export
 */
export const GetTripsByIdAndPartialSearchContextIncludeIntermediateStopsEnum = {
    All: 'ALL',
    BoardingAlighting: 'BOARDING_ALIGHTING',
    None: 'NONE'
} as const;
export type GetTripsByIdAndPartialSearchContextIncludeIntermediateStopsEnum = typeof GetTripsByIdAndPartialSearchContextIncludeIntermediateStopsEnum[keyof typeof GetTripsByIdAndPartialSearchContextIncludeIntermediateStopsEnum];
/**
 * @export
 */
export const GetTripsByLegAcceptLanguageEnum = {
    De: 'de',
    Fr: 'fr',
    It: 'it',
    En: 'en'
} as const;
export type GetTripsByLegAcceptLanguageEnum = typeof GetTripsByLegAcceptLanguageEnum[keyof typeof GetTripsByLegAcceptLanguageEnum];
/**
 * @export
 */
export const GetTripsByOriginAndDestinationAcceptLanguageEnum = {
    De: 'de',
    Fr: 'fr',
    It: 'it',
    En: 'en'
} as const;
export type GetTripsByOriginAndDestinationAcceptLanguageEnum = typeof GetTripsByOriginAndDestinationAcceptLanguageEnum[keyof typeof GetTripsByOriginAndDestinationAcceptLanguageEnum];
/**
 * @export
 */
export const GetTripsByRedefinitionAcceptLanguageEnum = {
    De: 'de',
    Fr: 'fr',
    It: 'it',
    En: 'en'
} as const;
export type GetTripsByRedefinitionAcceptLanguageEnum = typeof GetTripsByRedefinitionAcceptLanguageEnum[keyof typeof GetTripsByRedefinitionAcceptLanguageEnum];
/**
 * @export
 */
export const GetTripsByRoadAcceptLanguageEnum = {
    De: 'de',
    Fr: 'fr',
    It: 'it',
    En: 'en'
} as const;
export type GetTripsByRoadAcceptLanguageEnum = typeof GetTripsByRoadAcceptLanguageEnum[keyof typeof GetTripsByRoadAcceptLanguageEnum];
/**
 * @export
 */
export const GetTripsIntervalByOriginAndDestinationAcceptLanguageEnum = {
    De: 'de',
    Fr: 'fr',
    It: 'it',
    En: 'en'
} as const;
export type GetTripsIntervalByOriginAndDestinationAcceptLanguageEnum = typeof GetTripsIntervalByOriginAndDestinationAcceptLanguageEnum[keyof typeof GetTripsIntervalByOriginAndDestinationAcceptLanguageEnum];
